import React, { Component } from 'react';
import YouTube from 'react-youtube';

import classNames from 'classnames'

class YouTubeContainer extends Component {
  constructor() {
    super();
    this.state = {
      player: null
    }
  }

  
  componentWillUpdate(nextProps, nextState){
    if(!nextProps.active && this.props.active){
      this.pausePlayer()
    }
  }

  setPlayer(event){
  	this.setState({ player: event.target })
  }

  pausePlayer(){
    if(this.state.player){
      this.state.player.pauseVideo()
    }
  }

  render() {
  	let classes = classNames({
          active: this.props.active
        });
    const opts = {
      playerVars: {
        rel: 0
      }
    }
    return (
      <div className="YouTubeContainer">
      	<YouTube videoId={this.props.videoId} className={classes} onReady={this.setPlayer.bind(this)} opts={opts}/>
      </div>
    );
  }
}

export default YouTubeContainer;


// WEBPACK FOOTER //
// ./src/Components/YouTubeContainer.js